import { render, staticRenderFns } from "./news-area.vue?vue&type=template&id=0ba94946&scoped=true&"
import script from "./news-area.vue?vue&type=script&lang=js&"
export * from "./news-area.vue?vue&type=script&lang=js&"
import style0 from "./news-area.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./news-area.vue?vue&type=style&index=1&id=0ba94946&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0ba94946",
  null
  
)

export default component.exports